import { companyPartnerIntegrationsService, IntegrationType } from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface RemoveIntegrationTypeParams {
  id: string;
  companyId: string;
  integrationType: IntegrationType;
}

const useRemoveIntegrationType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, integrationType }: RemoveIntegrationTypeParams) =>
      companyPartnerIntegrationsService.removeType(id, integrationType),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchCompanyIntegrations', companyId] });
    },
  });
};

export default useRemoveIntegrationType;
